import { VerifiedEmail } from '@gofranz/common';
import { IsVerified } from '@gofranz/common-components';
import { ActionIcon, Grid, Group, Text, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

export interface FormsRecipientProps {
  verifiedEmail: VerifiedEmail;
  form_id: string;
  isBusy: boolean;
  deleteCb: (formId: string, integrationId: string) => Promise<void>;
  isAutoResponseEnabled: boolean;
  recipientCount: number;
}

export function FormRecipient(props: FormsRecipientProps) {
  const { verifiedEmail, form_id, isAutoResponseEnabled, recipientCount } = props;
  const isLastRecipient = recipientCount === 1;
  const isDeleteDisabled = isLastRecipient && isAutoResponseEnabled;

  const deleteButton = (
    <ActionIcon
      color="red"
      onClick={() => props.deleteCb(form_id, verifiedEmail.id)}
      loading={props.isBusy}
      variant="filled"
      aria-label="Delete"
      disabled={isDeleteDisabled}
    >
      <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
    </ActionIcon>
  );

  return (
    <Grid>
      <Grid.Col span={5}>
        <Group>
          {isDeleteDisabled ? (
            <Tooltip label="Cannot remove the last email recipient while auto-response is enabled. Please disable auto-response first.">
              {deleteButton}
            </Tooltip>
          ) : (
            deleteButton
          )}
          <Text>{verifiedEmail.email}</Text>
        </Group>
      </Grid.Col>
      <Grid.Col span="auto">
        <IsVerified isVerified={verifiedEmail.is_verified} />
      </Grid.Col>
    </Grid>
  );
}
